import React from 'react'

const Person = ({ className = '', color = '#151f31' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 9C9.89511 9 10.7536 8.64442 11.3865 8.01149C12.0194 7.37855 12.375 6.52011 12.375 5.625C12.375 4.72989 12.0194 3.87145 11.3865 3.23851C10.7536 2.60558 9.89511 2.25 9 2.25C8.10489 2.25 7.24645 2.60558 6.61351 3.23851C5.98058 3.87145 5.625 4.72989 5.625 5.625C5.625 6.52011 5.98058 7.37855 6.61351 8.01149C7.24645 8.64442 8.10489 9 9 9ZM11.25 5.625C11.25 6.22174 11.0129 6.79403 10.591 7.21599C10.169 7.63795 9.59674 7.875 9 7.875C8.40326 7.875 7.83097 7.63795 7.40901 7.21599C6.98705 6.79403 6.75 6.22174 6.75 5.625C6.75 5.02826 6.98705 4.45597 7.40901 4.03401C7.83097 3.61205 8.40326 3.375 9 3.375C9.59674 3.375 10.169 3.61205 10.591 4.03401C11.0129 4.45597 11.25 5.02826 11.25 5.625ZM15.75 14.625C15.75 15.75 14.625 15.75 14.625 15.75H3.375C3.375 15.75 2.25 15.75 2.25 14.625C2.25 13.5 3.375 10.125 9 10.125C14.625 10.125 15.75 13.5 15.75 14.625ZM14.625 14.6205C14.6239 14.3438 14.4517 13.5112 13.689 12.7485C12.9555 12.015 11.5751 11.25 9 11.25C6.42375 11.25 5.0445 12.015 4.311 12.7485C3.54825 13.5112 3.37725 14.3438 3.375 14.6205H14.625Z"
        fill={color}
      />
    </svg>
  )
}

export default Person
